export const OVERVIEW_PATH = '/property-bills';
export const OVERVIEW_FINISHED_PATH = '/property-bills/finished';
export const OVERVIEW_TESTING_PATH = '/property-bills/testing';

export const CHANNEL_PATH = '/property-bills/channels/:channelId';
export const CHANNEL_FINISHED_PATH = '/property-bills/channels/:channelId/finished';
export const CHANNEL_TESTING_PATH = '/property-bills/channels/:channelId/testing';
export const CHANNEL_CONFIG_PATH = '/property-bills/channels/:channelId/config/:tab?/:configId?';
export const CHANNEL_MASTERDATA_PATH = '/property-bills/channels/:channelId/masterdata';

export const ASSISTANCE_PATH = '/property-bills/:recordId';
export const ASSISTANCE_TAB_PATH = '/property-bills/:recordId/:tab';
export const ITEMS_PER_PAGE = 50;
